import { faUsers } from "@fortawesome/pro-duotone-svg-icons/faUsers";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_USERS_LINK: Breadcrumb = {
  icon: faUsers,
  name: "Users",
  to: "/dashboard/users",
};
